import { render, staticRenderFns } from "./StudentCommunityProfileEdit.vue?vue&type=template&id=8a1b3c8a&scoped=true&"
import script from "./StudentCommunityProfileEdit.vue?vue&type=script&lang=js&"
export * from "./StudentCommunityProfileEdit.vue?vue&type=script&lang=js&"
import style0 from "./StudentCommunityProfileEdit.vue?vue&type=style&index=0&id=8a1b3c8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1b3c8a",
  null
  
)

export default component.exports